import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, gamesCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a template view.
 * @extends JetView
 */
export default class templateView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const id_template = this.getParam('id', true); // Get template ID from parameters
        return {
            rows: [
                {
                    id: 'Template1', // ID for the main template container
                    cols: [
                        {
                            view: 'form', // Form view for input
                            id: 'addform', // ID for the form
                            elements: [
                                {
                                    view: 'ckeditor5', // CKEditor for rich text editing
                                    label: _('Plantilla'), // Label for the editor
                                    name: 'Template', // Name of the field
                                    id: 'Template', // ID for the editor
                                    onReady(eventData) {
                                        // Event when the editor is ready
                                        eventData.plugins.get('FileRepository').createUploadAdapter = function (
                                            loader,
                                        ) {
                                            return new UploadAdapter(loader); // Custom upload adapter
                                        };
                                    },
                                    ready: function (eventData) {
                                        // Another event for when the editor is ready
                                        eventData.plugins.get('FileRepository').createUploadAdapter = function (
                                            loader,
                                        ) {
                                            return new UploadAdapter(loader); // Custom upload adapter
                                        };
                                    },
                                },
                                {
                                    view: 'button', // Button for saving the template
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Button label
                                    click: function ($e) {
                                        // Click event handler
                                        var values = $$('addform').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        values.Id = id_template; // Add template ID to values
                                        webix
                                            .ajax() // AJAX request to save the template
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Partners/SaveTemplateSMS', // API endpoint
                                                JSON.stringify(values), // Send values as JSON
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message({
                                                            // Show error message
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _('Ocurrio un error, comuniquese con soporte'),
                                                        });
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text); // Parse response
                                                        if (
                                                            !response.HasError // Check for errors
                                                        ) {
                                                            webix.message(
                                                                _(
                                                                    'Plantilla SMS guardada', // Success message
                                                                ),
                                                            );
                                                        } else {
                                                            webix.message({
                                                                // Show error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error, comuniquese con soporte'),
                                                            });
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Clear form values after submission
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const id_template = this.getParam('id', true); // Get template ID from parameters
        $$('Template1').hide(); // Hide the template initially
        var filter = {
            Partner: id_partner, // Filter object for AJAX request
            Id: id_template, // Template ID
        };
        webix
            .ajax() // AJAX request to get the template
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Partners/GetTemplateSMS', filter, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message({
                        // Show error message
                        title: _('¡Error!'),
                        type: 'alert-error',
                        text: _('Ocurrio un error, comuniquese con soporte'),
                    });
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    if (!resp.HasError) {
                        // Check for errors
                        $$('Template1').show(); // Show the template
                        $$('Template').setValue(resp.Data.Template); // Set the template value
                    } else {
                        webix.message({
                            // Show error message
                            title: _('¡Error!'),
                            type: 'alert-error',
                            text: _('Ocurrio un error, comuniquese con soporte'),
                        });
                    }
                },
            });
    }
}

// FILE DOCUMENTED
